/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankAccountDto
 */
export interface BankAccountDto {
    /**
     * Unique identifier of the bank account
     * @type {string}
     * @memberof BankAccountDto
     */
    id: string;
    /**
     * Unique identifier of the person who owns the account
     * @type {string}
     * @memberof BankAccountDto
     */
    personId: string;
    /**
     * International Bank Account Number
     * @type {string}
     * @memberof BankAccountDto
     */
    iban: string;
    /**
     * Label or name of the bank account
     * @type {string}
     * @memberof BankAccountDto
     */
    label: string;
    /**
     * Indicates if this is the default bank account for the person
     * @type {boolean}
     * @memberof BankAccountDto
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountDto
     */
    isSelected: boolean;
    /**
     * Date and time when the bank account was created
     * @type {Date}
     * @memberof BankAccountDto
     */
    creationTime: Date;
}

/**
 * Check if a given object implements the BankAccountDto interface.
 */
export function instanceOfBankAccountDto(value: object): value is BankAccountDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('iban' in value) || value['iban'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    if (!('isSelected' in value) || value['isSelected'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    return true;
}

export function BankAccountDtoFromJSON(json: any): BankAccountDto {
    return BankAccountDtoFromJSONTyped(json, false);
}

export function BankAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'personId': json['personId'],
        'iban': json['iban'],
        'label': json['label'],
        'isDefault': json['isDefault'],
        'isSelected': json['isSelected'],
        'creationTime': (new Date(json['creationTime'])),
    };
}

export function BankAccountDtoToJSON(json: any): BankAccountDto {
    return BankAccountDtoToJSONTyped(json, false);
}

export function BankAccountDtoToJSONTyped(value?: BankAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personId': value['personId'],
        'iban': value['iban'],
        'label': value['label'],
        'isDefault': value['isDefault'],
        'isSelected': value['isSelected'],
        'creationTime': ((value['creationTime']).toISOString()),
    };
}

